import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'


import router from './router/index'

/* agregado */
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
/* fin agregado */

/* agregado */
import { abilitiesPlugin } from '@casl/vue';
import ability from './casl/ability';
/* fin agregado */

/* agregado */
import moment from 'moment';
import 'moment/locale/es';
/* fin agregado */

// Este nno sé si es necesario
//import 'vuetify/dist/vuetify.min.css';
//Vue.use(vuetify);

Vue.config.productionTip = false

// Configuración de Vue Toastification
const toastOptions = {
  position: 'bottom-right',
  timeout: 3000,
  closeOnClick: true,
};

Vue.use(Toast, toastOptions);
// Fin Configuración de Vue Toastification

// Configuración de Moment
moment.locale('es');

Vue.prototype.$moment = moment;
window.moment = moment;
// Fin Configuración de Moment

// Configuración de casl
Vue.use(abilitiesPlugin, ability, {
  useGlobalProperties: true
});
// Fin Configuración de casl

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
